module.exports = __webpack_public_path__ + "img/handler-icon.33020246.svg";